import { ENDPOINTS } from '../../environments/environment';
import { of, throwError } from 'rxjs';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { constants } from '../constants/constants';

export const guestSummary500 = () => {
	const result = [
		// 0
		{
			[ENDPOINTS.API_MICROSERVICE_RETRIEVE_ONBOARD_PAYMENT]: () => {
				return throwError(new HttpErrorResponse({ status: 500 }));
			}
		},
		// 1
		{
			[ENDPOINTS.API_GET_ARRIVAL_TIME]: () => {
				return throwError(new HttpErrorResponse({ status: 500 }));
			}
		}
	];

	return result;
};

export const guestSummary200 = () => {
	const result = [
		// 0
		{
			[ENDPOINTS.API_MICROSERVICE_RETRIEVE_ONBOARD_PAYMENT]: () => {
				return of(
					new HttpResponse({
						body: {
							status: constants.HTTP_STATUS_CODE.BACKEND_ERROR,
							errors: [
								{
									internalMessage: 'Unknown error occurred.',
									id: '804acad0-2c2f-443e-a5ec-bd67b176a9ae',
									time: 1525122442920
								}
							]
						}
					})
				);
			}
		},
		// 1
		{
			[ENDPOINTS.API_GET_ARRIVAL_TIME]: () => {
				return of(new HttpResponse({ body: { statusCode: 344, status: constants.HTTP_STATUS_CODE.BACKEND_ERROR } }));
			}
		}
	];

	return result;
};
